import { render, staticRenderFns } from "./InvoiceReceiptReceives.vue?vue&type=template&id=a5dde4e4&"
import script from "./InvoiceReceiptReceives.vue?vue&type=script&lang=js&"
export * from "./InvoiceReceiptReceives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports